export enum ETipoLogin {
    Participante = 'participante',
    GSI = 'gsi'
}
